import React, { useState, useEffect } from 'react'

import { SAFEWALK_SET_DATA } from '@actions/types'

import { useSelector, useDispatch } from 'react-redux'
import { selectAccountConfig } from '@selectors'

import { SHOW_ACTION_SHEET } from '@redux/actions/types'

import localForage from 'localforage'

import SafeWalkStart from '@components/safewalk-start/safewalk-start.component'
import SafeWalkSetup from '@components/safewalk-setup/safewalk-setup.component'
import SafeWalkOffCampus from '@components/safewalk-off-campus/safewalk-off-campus.component'
import SafeWalkOnCampus from '@components/safewalk-on-campus/safewalk-on-campus.component'

import dayjs from 'dayjs'

const SafeWalkContainer = () => {
  const dispatch = useDispatch()
  const [setupState, setSetupState] = useState('')

  const accountConfig = useSelector(selectAccountConfig)
  const activeDisplay = useSelector(state => state.safewalk.activeDisplay)

  const safeWalkConfig = accountConfig?.safe_walk

  useEffect(() => {
    (async () => {
      const installBanner = await localForage.getItem('installBanner')

      if (installBanner) {
        const now = dayjs.duration(Date.now()).asMilliseconds()
        const bannerDate = dayjs.duration(installBanner?.dateCreated).asMilliseconds()
        const diff = now - bannerDate
  
        // If last update is greater than 24hrs, prompt the user with install banner again.
        if (diff >= 86400000) {
          dispatch({ type: SHOW_ACTION_SHEET, payload: 'INSTALL' })
        }
      } else {
        dispatch({ type: SHOW_ACTION_SHEET, payload: 'INSTALL' })
      }
    })()
  })

  if (!safeWalkConfig) return null

  const {
    alert_on_off_site_walk: alertOnOffSiteWalk,
    alert_on_weekend_walk: alertOnWeekendWalk,
    hours_of_operation: hoursOfOperation
  } = { ...safeWalkConfig }

  const { end_time: endTime, start_time: startTime } = hoursOfOperation

  const formatStartTime = dayjs().hour(startTime.hour).minute(startTime.min)
  const formatEndTime = dayjs().hour(endTime.hour).minute(endTime.min)

  const isDuringHours = dayjs().isBetween(formatStartTime, dayjs(formatEndTime), 'minutes')
  const isWeekend = dayjs().day() === 6 || dayjs().day() === 0

  const shouldAlertOnWeekend = alertOnWeekendWalk && isWeekend

  const goToOffCampusSetup = () => {
    if (alertOnOffSiteWalk) return false

    if (!isDuringHours) return true

    if (shouldAlertOnWeekend && !isDuringHours) return true

    if (setupState === 'offCampus') return true

    return false
  }

  const handleOnClickOnCampus = () => {
    setSetupState('onCampus')
    dispatch({ type: SAFEWALK_SET_DATA, payload: { isOnCampus: true } })
  }

  const handleOnClickOffCampus = () => {
    setSetupState('offCampus')
    dispatch({ type: SAFEWALK_SET_DATA, payload: { isOnCampus: false } })
  }

  if (activeDisplay) return <SafeWalkStart />

  if (goToOffCampusSetup()) return <SafeWalkOffCampus />

  if (setupState === 'onCampus' || alertOnOffSiteWalk) return <SafeWalkOnCampus />

  return <SafeWalkSetup
    onClickOffCampus={handleOnClickOffCampus}
    onClickOnCampus={handleOnClickOnCampus}
  />
}

export default SafeWalkContainer
